<div class="stub">
  {{ 'classrooms.invite.stub.title' | customLocale }}<br>  
  {{ 'classrooms.invite.stub.description' | customLocale }}
  <!-- <span class="invite-link" (click)="openInviteModal()">Оправить приглашение</span> -->
</div>